<template>
   <div class="content-wrapper">
      <section class="content-header">
         <div class="row">
            <div class="col-xs-8" align="left">
               <h1>Search VPN Coupon List</h1>
            </div>
            <div class="col-xs-4">
               <a class="btn btn-sm btn-add" @click="RefreshNow">
                  <i class="fa fa-refresh"></i>Refresh
               </a>
            </div>
         </div>
      </section>
      <section class="content">
         <form v-on:submit.prevent="dopagination(0)">
         <div class="row">
            <div class="col-xs-6 col-sm-3 form-group">
               <input placeholder="Coupon Code" type="text" name="coupon_code" v-model="coupon_code" id="coupon_code" class="form-control input-sm" value="">
            </div>
            <div class="col-xs-6 col-sm-3 form-group">
               <select title="" name="status" v-model="status" v-select="status" id="status" class="form-control input-sm select2" @change="dopagination(0)">
                  <option value="">All</option>
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
               </select>
            </div>
            <div class="col-xs-3 col-sm-1 form-group">
               <select title="" name="limit" id="limit" v-model="display_limit" v-select="display_limit" class="form-control input-sm select2" @change="dopagination(0)">
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="75">75</option>
                  <option value="100">100</option>
               </select>
            </div>
            <div class="col-xs-2 form-group">
               <button type="submit" class="btn btn-sm btn-submit">
                  <i class="fa fa-search"></i> Search
               </button>
            </div>
         </div>
         </form>
         <div class="row">
            <div class="col-sm-12">
               <div class="alert alert-info" v-if="alert_message">
                  {{alert_message}}
               </div>
            </div>
            <div class="col-md-12">
               <div class="box">
                  <div class="box-header">
                     <h3 class="box-title">
                        Total : {{totalData}} 
                        <span v-if="dispplayFrom">
                           Showing {{dispplayFrom}} to {{dispplayTo}}
                        </span>
                        <span class="pull-right noOfData">
                           {{totalData}}
                        </span>
                     </h3>
                  </div>
                  <div class="box-body">
                     <div class="table-responsive">
                        <table class="table table-0024 table-bordered table-striped">
                           <thead>
                              <tr>
                                 <th class="tdCenter tdSN">SN</th>
                                 <th>VPN Campaign Name </th>
                                 <th>VPN Coupon Code </th>
                                 <th>My Share</th>
                                 <th>Start At</th>
                                 <th>End At</th>
                                 <th class="tdCenter">Sold VPN Subscriptions</th>
                                 <th class="tdCenter">VPN Campaign Link</th>
                                 <th class="tdCenter">Status</th>
                              </tr>
                           </thead>
                           <tbody v-if="campaignArr.length > 0">
                              <tr v-for="(data, index) in campaignArr" :key="data.id">
                                 <td class="tdCenter tdSN">
                                    {{parseInt(index)+1}}
                                 </td>
                                 <td>{{data.name}}</td>
                                 <td>{{data.coupon_code}}</td>
                                 <td>
                                    {{data.affiliate_share_percent}} %
                                 </td>
                                 <td>{{data.start_at}}</td>
                                 <td>{{data.end_at}}</td>
                                 <td class="tdCenter">
                                    <router-link :to="`campaignlist/${data.id}`"  title="Browse">
                                       {{data.sold_pins}}
                                    </router-link>
                                 </td>
                                 <td class="tdCenter">
                                    <a href="#"
                                       title="Browse" class="btn btn-sm btn-payment colorbox" @click="loadCampaignLinks(data.id)">
                                       <i class="fa fa-list"></i>
                                       <span>Browse</span>
                                    </a>
                                 </td>
                                 <td class="tdCenter" v-if="data.status==1">
                                    <span class='label label-success'>Active</span>
                                 </td>
                                 <td class="tdCenter" v-else>
                                    <span class='label label-danger'>Inactive</span>
                                 </td>
                              </tr>
                           </tbody>
                           <tbody v-else>
                              <tr>
                                 <td colspan="12" class="tdCenter" style="padding: 30px 0;">
                                    <b>No Records Found</b>
                                 </td>
                              </tr>
                           </tbody>
                        </table>
                     </div>

                     <div style="display: none;">
                        <div id="campaignLinkList">
                           <div class="box" style="padding: 20px;">
                              <div class="box-header">
                                 <h3 class="box-title">
                                    <b></b> Campaign Links
                                 </h3>
                              </div>
                              <div class="box-body">
                                 <table class="table table-0024 table-bordered table-striped">
                                    <thead>
                                       <tr>
                                          <th class="tdCenter tdSN">SN</th>
                                          <th class="tdCenter">Plan Name</th>
                                          <th class="tdCenter">Actual Price</th>
                                          <th class="tdCenter">Discount</th>
                                          <th class="tdCenter">Offer Price</th>
                                          <th class="tdCenter">Links</th>
                                          <th class="tdCenter">Actions</th>
                                       </tr>
                                    </thead>
                                    <tbody v-if="linkArr.length > 0">
                                       <tr :class="val.actual_price==''?'warning':''" v-for="(val, index) in linkArr" >
                                          <td class="tdCenter tdSN">{{++index}}</td>
                                          <td class="tdCenter">{{val.plan_name}}</td>
                                          <td class="tdCenter">{{val.actual_price}}</td>
                                          <td class="tdCenter">
                                             {{val.discount}}
                                          </td>
                                          <td class="tdCenter">
                                             {{val.promo_price}}
                                          </td>
                                          <td :id="'link_'+index">{{val.link}}</td>
                                          <td class="tdCenter"> 
                                             <span v-if="val.actual_price !=''" class="label label-warning" @click="copyLink('link_'+index)" data-toggle="tooltip" data-placement="top" title="Click To Copy" style="cursor: copy;"> Copy Link </span>
                                          </td>
                                       </tr>
                                    </tbody>
                                    <tbody v-else>
                                       <tr>
                                          <td colspan="7" class="tdCenter" style="padding: 30px 0px;"> No Records Found </td>
                                       </tr>
                                    </tbody>
                                 </table>
                              </div>
                           </div>

                        </div>
                     </div>
                     
                     <div class="pagination" v-if="last_page > 1">
                        <a v-if="prev_page_url" href="#" @click="dopagination(prevPage)" class="next">
                           « Previous
                        </a>
                        <span v-else class="disabled">« Previous</span>
                        <span v-if="last_page > max_display_pagination">
                           <span v-for="index in last_page">
                              <span v-if="index==1||index==2">
                                 <span class="current" v-if="index==current_page">
                                    {{index}}
                                 </span>
                                 <span v-else>
                                    <a href="#" @click="dopagination(index)">
                                       {{index}}
                                    </a>
                                 </span>
                                 <span v-if="(index==2) && firstDotted">..</span>
                              </span>
                              <span v-if="randomPageNumber.includes(index)">
                                 <span class="current" v-if="index==current_page">
                                    {{index}}
                                 </span>
                                 <span v-else>
                                    <a href="#" @click="dopagination(index)">
                                       {{index}}
                                    </a>
                                 </span>
                              </span>
                              <span v-if="index==last_page||index==last_page-1">
                                 <span v-if="(index==last_page-1) && lastDotted">
                                    ..
                                 </span>
                                 <span class="current" v-if="index==current_page">
                                    {{index}}
                                 </span>
                                 <span v-else>
                                    <a href="#" @click="dopagination(index)">
                                       {{index}}
                                    </a>
                                 </span>
                              </span>
                           </span>
                        </span>
                        <span v-else>
                           <span v-for="index in last_page">
                              <span class="current" v-if="index==current_page">
                                 {{index}}
                              </span>
                              <span v-else>
                                 <a href="#" @click="dopagination(index)">{{index}}</a>
                              </span>
                           </span>
                        </span>
                        <a v-if="next_page_url" href="#" @click="dopagination(nextPage)" class="next">
                           Next »
                        </a>
                        <span v-else class="disabled">Next »</span>
                     </div>
                  </div>
                  <div class="box-footer"></div>
               </div>
            </div>
         </div>
      </section>
   </div>
</template>
<script>
   import axios from 'axios'
   export default {
      name: "CampaignList",
      data() {
         return {
            campaignArr : {},
            coupon_code : '',
            full_name : '',
            status : 1,
            dispplayFrom : 0,   
            dispplayTo : 0,  
            totalData : 0, 
            display_limit : 50,

            websiteArr : {},
            linkArr : {},
            
            amount : '',
            pay_amount : '',
            type : 1,
            creationdate : '',
            description : '',
            alert_message : '',
            userData : '',

            // Pagination Variables
            prev_page_url : false,
            next_page_url : false,
            last_page : 1,
            current_page : null,
            max_display_pagination : 9,
            randomPageNumber : {}, 
            firstDotted: false,
            lastDotted: false,
            prevPage : '',
            nextPage : '',
         }
      },
      created(){
         this.com_user_type_access([1,2,4,5,6,7,0]);
         var encryptedData = this.$store.getters.getUser;
         var decodedString  = this.com_DecryptString(encryptedData);
         var userData = JSON.parse(decodedString);
         this.userData = userData;
         if(userData.user_level == 1) {
            this.$router.push('dashboard');
         }

         //this.loadAllResellers();
         this.dopagination(0);
      },
      methods: {
         dopagination(page_no = ''){
            loader.show();
            var rootObject = this;
            rootObject.creationdate = this.com_currentDateTime();
            let querystr = 'coupon_code='+this.coupon_code+'&status='+this.status+'&paginate='+this.display_limit; 
            if(page_no > 0){
               querystr +="&page="+page_no;
            }
            //console.log(querystr);

            axios.get('affiliate/campaign-coupons?'+querystr).then(function (response) {
               rootObject.populateCampaignData(response);
               //console.log(response);
               rootObject.websiteArr=response.data.website_payment_domains;
            })
            .catch(function (error) {
                let alertmessage = "";
                for (var prop in error.response.data) {
                  alertmessage += ' '+error.response.data[prop]
                }
                console.log(alertmessage);
                loader.hide();
                rootObject.com_errorHandel(error);
            });
         },

         populateCampaignData(response){
            this.campaignArr = response.data.couponList.data;
            this.totalData = response.data.couponList.total;
            this.dispplayFrom = response.data.couponList.from;
            this.dispplayTo = response.data.couponList.to;
            this.display_limit = response.data.couponList.per_page;
            this.paginationGenerate(response);
            loader.hide();
         },

         paginationGenerate(response){
            this.prev_page_url = response.data.couponList.prev_page_url;
            this.next_page_url = response.data.couponList.next_page_url;
            this.last_page = response.data.couponList.last_page;
            this.current_page = response.data.couponList.current_page;
            this.randomPageNumber = [];
            this.firstDotted = false;
            this.lastDotted = false;
            this.prevPage = this.current_page-1;
            this.nextPage = this.current_page+1;
            let countableOtherPages = this.max_display_pagination-4;
            if(this.current_page==1 || this.current_page ==2){
               for(let i = 3; i <= (3+(countableOtherPages-1)); i++){
                  this.randomPageNumber.push(i);
               }
               this.lastDotted=true;
            }
            else if(this.current_page==this.last_page || this.current_page ==this.last_page-1){
               let endPage = this.last_page-2;
               for(let i = endPage; i >= endPage - (countableOtherPages-1); i--){
                  this.randomPageNumber.push(i);
               }
               this.firstDotted = true;
            }
            else{
               let interval = parseInt(countableOtherPages / 2);
               if(this.current_page <= (interval+3)){
                  for(let i = 3; i <= (3+(countableOtherPages-1)); i++){
                     this.randomPageNumber.push(i);
                  }
                  this.lastDotted=true;
               }
               else if (this.current_page >= (this.last_page - (interval+2))) 
               {
                  let endPage = this.last_page-2;
                  for(let i = endPage; i >= endPage - (countableOtherPages-1); i--){
                     this.randomPageNumber.push(i);
                  }
                  this.firstDotted = true;
               }else{
                  for(let i = this.current_page; i <= (this.current_page+interval); i++){
                     this.randomPageNumber.push(i);
                  }

                  for(let i = (this.current_page-1); i >= (this.current_page-interval); i--){
                     this.randomPageNumber.push(i);
                  }
               }
            }
            //console.log(this.randomPageNumber);
         },

         loadCampaignLinks(campaign_id) {
            loader.show();
            var rootObject = this;
            axios.get('affiliate/campaign-coupons-link?campaign_id='+campaign_id).then(function (response) {
               //console.log(response);
               rootObject.loadLinkPopup(campaign_id, response.data.ratePlans);
            })
            .catch(function (error) {
               console.log(error);
                let alertmessage = "";
                for (var prop in error.response.data) {
                  alertmessage += ' '+error.response.data[prop]
                }
                console.log(alertmessage);
                loader.hide();
                rootObject.com_errorHandel(error);
            });
         },

         loadLinkPopup(campaign_id, ratePlanArr){
            this.linkArr = [];
            var links = [];
            var enc_campaign_id = this.com_EncryptString(campaign_id, 'SymKolpo321(fd#]');

            if(ratePlanArr.length > 0){
               for (var prop in this.websiteArr) {
                  var dynamicLinks = [];
                  var domain_link = this.websiteArr[prop];
                  dynamicLinks['plan_name']     = 'All Plans ( '+ domain_link + ' )';
                  dynamicLinks['actual_price']  = '';
                  dynamicLinks['promo_price']   = '';
                  dynamicLinks['link']          = '';
                  links.push(dynamicLinks);

                  for (var prop2 in ratePlanArr) {
                     var dynamicLinks = [];
                     dynamicLinks['plan_name'] = ratePlanArr[prop2]['plan_name'];
                     dynamicLinks['actual_price'] = '$'+ratePlanArr[prop2]['price'];
                     
                     var discount_amount = ratePlanArr[prop2]['discount_amount'];
                     if(ratePlanArr[prop2]['discount_type']==1){
                        dynamicLinks['discount'] = '$'+discount_amount;
                        var promo_price = parseFloat(ratePlanArr[prop2]['price'])-parseFloat(discount_amount);
                     }else{
                        dynamicLinks['discount'] = discount_amount+'%';
                        var promo_price = parseFloat(ratePlanArr[prop2]['price'])-((parseFloat(ratePlanArr[prop2]['price'])*parseFloat(discount_amount))/100);
                     }

                     dynamicLinks['promo_price'] = '$'+promo_price;
                     dynamicLinks['link'] = domain_link+'/checkout/'+ratePlanArr[prop2]['id']+'?referral='+enc_campaign_id;
                     links.push(dynamicLinks);
                  }
               }
            }

            this.linkArr = links;
            //console.log(links);

            setTimeout(function(){  
               $('.colorbox').colorbox({opacity: 0.8, height: '350px', width: '80%', 'inline':true, 'open':true, href:function(){return "#campaignLinkList"; }});
               loader.hide();
            }, 500);
         },

         RefreshNow(){
            this.dopagination(0);
         },

         copyLink(id){
             //console.log(id);
             var range = document.createRange();
             range.selectNode(document.getElementById(id));
             window.getSelection().removeAllRanges(); // clear current selection
             window.getSelection().addRange(range); // to select text
             document.execCommand("copy");
             //window.getSelection().removeAllRanges();// to deselect
             toastr.info(' Link copied to clipboard!');
         }

      },

      mounted: function() {
         $(".select2").select2();
      }
   };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>